(function () {
  function hoverMainMenu() {
    var self = this;
    this.init = function (obj, e) {
      var subMenu = $('#' + obj.dataset.child);
      var mainMenu = $('.' + obj.dataset.parent);

      this.obeserveNav(subMenu);
      var imageCategory = $('.submenu-wrap.open').find(
        '.image-wrap .image_menu_container',
      );
      var defaultMedia = imageCategory.attr('default_image');
      imageCategory.css('background-image', 'url(' + defaultMedia + ')');
      if (this.checkIfExist(subMenu)) {
        this.openSubMenu(subMenu, mainMenu);
      } else {
        this.clearAllMenu();
      }
    };

    this.clearAllMenu = function () {
      $('.linktoactive').each(function () {
        $(this).removeClass('current');
      });

      $('.submenu-wrap').each(function () {
        $(this).find('.submenu').addClass('invisible');
        $(this).find('.op').addClass('hide');
        $(this).addClass('hide');
        $(this).removeClass('open');
      });
    };

    this.openSubMenu = function (submenu, mainMenu) {
      if (submenu.hasClass('open')) return;
      this.clearAllMenu();
      mainMenu.find('a').addClass('current');
      submenu.addClass('open');
      submenu.removeClass('hide');
      submenu.find('.submenu_lvl0').removeClass('invisible');
      submenu.find('.image-wrap').removeClass('invisible');

      var level2Links = submenu.find('.submenu_lvl0').find('.submenu_link');
      if (level2Links.length) {
        level2Links.first().trigger('open.menu.oc');
      }
    };

    this.checkIfExist = function (submenu) {
      if (submenu[0]) {
        return true;
      }
      return false;
    };

    this.obeserveNav = function (obj) {
      $(obj)
        .mouseenter(function () {})
        .mouseleave(function () {
          self.clearAllMenu();
        });
    };
  }

  $('.main_menu_link').on('mouseenter', function (e) {
    var menu_mobile = 1375;
    if (jQuery(window).outerWidth(true) > menu_mobile) {
      new hoverMainMenu().init(this, e);
    }
  });
})();
